// External Dependencies
import React from 'react';

// Internal Dependencies
import DialogAddNinja from './update-ninjas-dialog/';
import NinjasTable from './ninjas-table';
import NinjasToolBar from './ninjas-toolbar';
import Title from '../../shared/title';

const rootStyles = {
  padding: 16,
  width: '100%',
};

// Component Definition
const UpdateNinjas = () => (
  <div style={rootStyles}>
    <Title>Update Ninjas</Title>
    <NinjasToolBar />
    <NinjasTable />
    <DialogAddNinja />
  </div>
);

export default UpdateNinjas;



/** WEBPACK FOOTER **
 ** ./src/dashboard/update-ninjas/index.js
 **/